/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */

/**
 * * `Right` - Right
* `Left` - Left
* `Switch` - Switch
 */
export type HandednessEnum = typeof HandednessEnum[keyof typeof HandednessEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HandednessEnum = {
  Right: 'Right',
  Left: 'Left',
  Switch: 'Switch',
} as const;
